/**
 * Small utility to replace certain encoding from query parameters to make the strings more readable.
 *
 * @param searchParams - a URLSearchParams object
 * @returns a stringified query parameter with %2C replaced with ,
 * @example
 * ```js
 * 'customer=foo%2Cbar' becomes 'customer=foo,bar'
 * ```
 */

export const encodeQueryParams = (searchParams: URLSearchParams): string =>
  searchParams.toString().replace(/%2C/g, ',');
